import React, { useState, useEffect }  from 'react';

import { styled } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";


import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

import Collapse from '@material-ui/core/Collapse';
import { Typography, Grid, useTheme } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles, { getMuiTheme } from "./styles";

import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CalculateIcon from '@mui/icons-material/Calculate';
import { pathOr } from "ramda";
import { FaIcon } from "../../../../../";
import { getCalculations } from '../../../../../../common/policyCalculation';
import SkeletonShell from "../../../../../../components/Skeleton/index";
import {configureDashlet } from "../../../../../../store/actions/dashboard.actions";
import { toast } from "react-toastify";


export default function CustomDashletList({data,setValue,value,allTabFilter,isDashletUpdated}) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  const dataList=pathOr( [], ['data'], data);
  const dataResult=pathOr([], ['result'], data);
  const listTypeStatic=pathOr(false, ['listTypeStatic'], data);
  const [dashId, setDashId] = useState(pathOr('', ['id'], data));
	const [showLoading,setShowLoading]= useState(isDashletUpdated.includes(dashId));
  const { dashboardData} = useSelector((state) => state.dashboard);
  const {	userPreference} = useSelector((state) => state.config);
	  // const currencies = pathOr([], ["attributes", "CurrenciesRecords"], userPreference);
    // console.log("dddddddddddddddd",pathOr(false, ['id'], data),isDashletUpdated)
    
    const filters = pathOr([], [0,'dashlets'], dashboardData).filter(element => element.data.subType === 'Filter');
  
  const filterarr=[];
  Object.values(filters).map((row) => {
    Object.values(row.data.data).map((fld) => {
      filterarr[fld.name]=fld;
  
    });
  });
  
  const {  configureDashletLoading } = useSelector(
    (state) => state.dashboard,
  );
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = (redirect,redirectData) => {
  if(redirect)
  {
    
    setValue(redirect)

  }else{

  
    if(dataList.redirectOn){
     
      let redirectFieldsArray=[]
      pathOr([], ['redirectFields'], dataList).map((rRow)=>{
        redirectFieldsArray.push({name:rRow,value:redirectData[rRow]})
      })
      // console.log(dataList.redirectOn,redirectData,...redirectFieldsArray)
      let redirectDestructData=[redirectFieldsArray]
      const params = {
        "configureDashlet": {
            "id": pathOr('', ['redirectDashlet'], dataList),
            "module": "HomeApp",
            "configure": "true",
            "redirected": "true",
            'type': 'custom',
            'data': {data:pathOr([], [0], redirectDestructData)},
            'currentTab': pathOr('', ['redirectOn'], dataList),
            'dashlets': []
        }

    };
    try {
        dispatch(configureDashlet(params)).then(function (res) {
            if (res.data.status === 200) {
                // console.log("configuredDashlet",res.data)
                // toast('Dashlet Configured Successfully!');
                // setConfiguredDashlet(res.data);
                // dispatch(getCurrentTab(value, 'this_year')).then((res) => {
                    
                    toast('Dashlet Updated Successfully!')
                    setValue(dataList.redirectOn)

                    // })

              } else {
                toast('Something went wrong!');

            }
        });
    } catch (e) {
        toast('Something went wrong!');

    }


    }else{
      setExpanded(!expanded);
    }
  } 
  };
  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));
  const handleCheck = (rData, val) => {
    return rData.some(item => val === item);
  }

  const showListTypeStatic=(fieldKey,fieldNum,cardNum,queryDataCurrencies,returnDataCurrencies)=>{
    let field =pathOr('', ['field'], fieldKey)
    return   <Grid container
    direction="row"
    // justifyContent="center"
    alignItems="center" 
    spacing={0}
    key={fieldNum}
    >
    <Grid item xs={12}>
      <Typography variant="subtitle1" className={classes.fieldLabel}>
        {pathOr('', ['label'], fieldKey)}
         :
      </Typography>
    </Grid>
    <Grid item xs={12}>
    {(configureDashletLoading && !isDashletUpdated.length) || (showLoading) ?<SkeletonShell layout="text" />:     <Typography variant="body2" gutterBottom style={{textTransform:'uppercase'}} color="textSecondary"  >
 
 
 {  handleCheck(queryDataCurrencies, field) ? getCalculations('getValueWithCurrency', pathOr('0', [cardNum,fieldNum], dataResult),[],allTabFilter) : handleCheck(returnDataCurrencies, field) ? getCalculations('getValueOnlyInDecimalAndPercent', pathOr('0', [cardNum,fieldNum], dataResult)) :pathOr('0', [cardNum,fieldNum], dataResult)}
      </Typography>}
    </Grid>
  </Grid>
  }
  const showCardBox=(cardItem,cardNum) => {
    const cardList = pathOr([], ['lists'], cardItem);
    let queryDataCurrencies = pathOr([], [ 'currencyFields'], cardItem);
    let returnDataCurrencies = pathOr([], [ 'returnFields'], cardItem);
 
 return <CardContent>
        <Grid container
         direction="row"
        //  justifyContent="space-between"
         alignItems="center">
        
          <Grid item xs={10}>
            {listTypeStatic?Object.values(cardList).map((fieldKey,fieldNum) => 
            showListTypeStatic(fieldKey,fieldNum,cardNum,queryDataCurrencies,returnDataCurrencies)

            ):
            // Object.keys(dataResult).map((fieldKey,fieldNum) => 
            Object.keys(dataList.fields).map((rowKey,rowNum) => 
            <Grid container
              direction="row"
              // justifyContent="center"
              alignItems="center" 
              spacing={0}
              key={rowNum}
              >
              <Grid item xs={5}>
                <Typography variant="subtitle1" className={classes.fieldLabel}>
                  {pathOr('', ['fields',rowKey],dataList )}
               
                </Typography>
              </Grid>
              <Grid item xs={7}>
              {(configureDashletLoading && !isDashletUpdated.length) || (showLoading) ?<SkeletonShell layout="text" />: <Typography variant="body2" gutterBottom style={{textTransform:'uppercase'}} color="textSecondary"  >
                {dataList.currencyFields.hasOwnProperty(rowKey)?getCalculations('getValueWithCurrency',pathOr('', ['data',cardNum,rowKey],dataResult ),[],allTabFilter):pathOr('', ['data',cardNum,rowKey],dataResult )}
                </Typography>}
              </Grid>
            </Grid>
            // )
            )}
          </Grid>
        <Grid item xs={2}>

            <ExpandMore
              expand={expanded}
              onClick={()=> handleExpandClick(cardItem.redirectOn,pathOr('', ['data',cardNum],dataResult ))}
              aria-expanded={expanded}
              aria-label="show more"
              color="primary"
            >
              {/* <ExpandMoreIcon /> */}
              {/* 17/04/23: Removed calculator icon from policy list */}
              {
                pathOr(false, ['redirectName'],dataList )==='Calculator'
                ? <CalculateIcon/>
                : pathOr(false, ['redirectName'],dataList ) === "" 
                  ? <></> 
                : <FaIcon icon={"fas fa-chevron-circle-right"} />
              }
            </ExpandMore>
          </Grid>
          <Grid item xs>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <CardContent>
            
              
              </CardContent>
            </Collapse>
          </Grid>

        </Grid>
      </CardContent>
  };

  return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>
      
      <Box >
        {listTypeStatic?Object.values(dataList).map((cardItem,cardNum) =>
          <Card variant="outlined"    key={cardNum}>
             {showCardBox(cardItem,cardNum)}

          </Card>

        ):dataResult.data.length?Object.values(dataResult.data).map((cardItem,cardNum) =>
         <Card variant="outlined"    key={cardNum}>
        {/* {console.log("dddddddddddddddcardItem",dataList,cardItem)} */}
          {showCardBox(cardItem,cardNum)}

        </Card>

      ): <Card variant="outlined"    key="nodata" ><Typography align="center" color="textSecondary">No Data</Typography></Card>}
      </Box>
    </MuiThemeProvider>
  );
}
